"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IpisButton = IpisButton;
var jsx_runtime_1 = require("react/jsx-runtime");
var framer_motion_1 = require("framer-motion");
var react_1 = require("react");
var IpisIconRouter_1 = require("../../components/icons/router/IpisIconRouter");
var brand_hooks_1 = require("../../hooks/brand-hooks");
var keyboard_event_hooks_1 = require("../../hooks/keyboard-event-hooks");
var tailwind_hooks_1 = require("../../hooks/tailwind-hooks");
var use_margin_1 = require("../../hooks/use-margin");
var client_utils_1 = require("../../utils/client-utils");
function IpisButton(props) {
    var _a, _b;
    var isOnline = !props.isOffline;
    var buttonRef = (0, react_1.useRef)(null);
    var theme = (0, brand_hooks_1.useExternalBrandTheme)().externalBrandTheme;
    var size = (_a = props.size) !== null && _a !== void 0 ? _a : "md";
    var margin = (0, use_margin_1.useMargin)(props.margin);
    var colors = (0, tailwind_hooks_1.useTailwindColors)();
    (0, keyboard_event_hooks_1.useOnEnterClick)({
        ref: buttonRef,
        callback: function () {
            var _a;
            (_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.click();
        },
    });
    var loading = props.loading, requiresNetworkConnection = props.requiresNetworkConnection, disabled = props.disabled, type = props.type, onlyIcon = props.onlyIcon, className = props.className, rest = __rest(props, ["loading", "requiresNetworkConnection", "disabled", "type", "onlyIcon", "className"]);
    var failsNetworkCheck = requiresNetworkConnection && !isOnline;
    var actAsDisabled = disabled || failsNetworkCheck;
    var variant = (_b = props.variant) !== null && _b !== void 0 ? _b : "primary";
    /*
        These are mostly auto-generated by CoPilot
        and needs to be validated before used.
      */
    /* const boxShadow =
        "0px 217px 61px rgba(112,112,104,0), 0px 139px 56px rgba(112,112,104,0.01), 0px 78px 47px rgba(112,112,104,0.04), 0px 35px 35px rgba(112,112,104,0.07), 0px 9px 19px rgba(112,112,104,0.08)"; */
    var boxShadow = "2px 2px 4px rgba(0, 0, 0, 0.2)";
    /* const emptyBoxShadow =
        "0px 0px 0px rgba(0, 0, 0, 0), 0px 0px 0px rgba(0, 0, 0, 0), 0px 0px 0px rgba(0, 0, 0, 0), 0px 0px 0px rgba(0, 0, 0, 0), 0px 0px 0px rgba(0, 0, 0, 0)"; */
    var emptyBoxShadow = "0px 0px 0px rgba(0, 0, 0, 0)";
    var transition = {
        duration: 0.2,
        ease: "easeInOut",
        color: { duration: 0.1 },
    };
    function getAnimations() {
        if (variant === "primary") {
            if (theme) {
                var animate = {
                    backgroundColor: actAsDisabled
                        ? theme.accentColor + "50"
                        : theme.accentColor,
                    color: actAsDisabled
                        ? theme.buttonTextColor + "50"
                        : theme.buttonTextColor,
                    //empty drop shadow to make animation work
                    boxShadow: emptyBoxShadow,
                    transition: transition,
                };
                var initial = animate;
                return {
                    initial: initial,
                    animate: animate,
                    whileHover: {
                        //drop shadow
                        boxShadow: boxShadow,
                        transition: transition,
                    },
                    whileTap: {
                        backgroundColor: colors.primary[500],
                        //remove drop shadow
                        boxShadow: emptyBoxShadow,
                        transition: transition,
                    },
                };
            }
            else {
                var animate = {
                    backgroundColor: actAsDisabled
                        ? colors.primary[100]
                        : colors.primary[400],
                    color: actAsDisabled ? colors.dark[300] : colors.dark[950],
                    //empty drop shadow to make animation work
                    boxShadow: emptyBoxShadow,
                    transition: transition,
                };
                var initial = animate;
                return {
                    initial: initial,
                    animate: animate,
                    whileHover: {
                        //drop shadow
                        boxShadow: boxShadow,
                        transition: transition,
                    },
                    whileTap: {
                        backgroundColor: colors.primary[500],
                        //remove drop shadow
                        boxShadow: emptyBoxShadow,
                        transition: transition,
                    },
                };
            }
        }
        if (variant === "outlined") {
            var animate = {
                backgroundColor: "rgba(0, 0, 0, 0)",
                color: actAsDisabled ? colors.dark[200] : colors.dark[950],
                border: "1px solid ".concat(actAsDisabled ? colors.dark[200] : colors.dark[950]),
                //empty drop shadow to make animation work
                boxShadow: emptyBoxShadow,
                transition: transition,
            };
            var initial = animate;
            return {
                initial: initial,
                animate: animate,
                whileHover: {
                    backgroundColor: colors.dark[900],
                    color: colors["light-background"],
                    boxShadow: "".concat(boxShadow),
                    transition: transition,
                },
                whileTap: {
                    backgroundColor: colors.dark[950],
                    color: colors["light-background"],
                    boxShadow: emptyBoxShadow,
                    transition: transition,
                },
            };
        }
        if (variant === "text") {
            var animate = {
                color: actAsDisabled ? colors.dark[200] : colors.accent,
                transition: transition,
            };
            var initial = animate;
            return {
                initial: initial,
                animate: animate,
                whileHover: {
                    color: colors.dark[400],
                    transition: transition,
                },
                whileTap: {
                    color: colors.dark[500],
                    transition: transition,
                },
            };
        }
        if (variant === "secondary-on-light-background") {
            var animate = {
                backgroundColor: actAsDisabled ? colors.dark[200] : colors.dark[950],
                color: actAsDisabled ? colors.dark[500] : colors["light-background"],
                //empty drop shadow to make animation work
                boxShadow: emptyBoxShadow,
                transition: transition,
            };
            var initial = animate;
            return {
                initial: initial,
                animate: animate,
                whileHover: {
                    backgroundColor: colors["light-background"],
                    boxShadow: "".concat(boxShadow),
                    color: colors.dark[950],
                    transition: transition,
                },
                whileTap: {
                    backgroundColor: colors["light-background"],
                    boxShadow: emptyBoxShadow,
                    color: colors.dark[950],
                    transition: transition,
                },
            };
        }
        if (variant === "secondary-on-dark-background") {
            var animate = {
                backgroundColor: "#ffffff",
                color: actAsDisabled ? colors.dark[200] : colors.dark[950],
                //empty drop shadow to make animation work
                boxShadow: emptyBoxShadow,
                transition: transition,
            };
            var initial = animate;
            return {
                initial: initial,
                animate: animate,
                whileHover: {
                    backgroundColor: colors.dark[900],
                    boxShadow: "".concat(boxShadow),
                    color: colors["light-background"],
                    transition: transition,
                },
                whileTap: {
                    backgroundColor: colors.dark[950],
                    boxShadow: emptyBoxShadow,
                    color: colors["light-background"],
                    transition: transition,
                },
            };
        }
        if (variant === "tonal") {
            var animate = {
                backgroundColor: colors.secondary[100],
                color: actAsDisabled ? colors.dark[300] : colors.dark[900],
                //empty drop shadow to make animation work
                boxShadow: emptyBoxShadow,
                transition: transition,
            };
            var initial = animate;
            return {
                initial: initial,
                animate: animate,
                whileHover: {
                    backgroundColor: colors.secondary[50],
                    boxShadow: "".concat(boxShadow),
                    color: colors.dark[900],
                    transition: transition,
                },
                whileTap: {
                    backgroundColor: colors.secondary[200],
                    boxShadow: emptyBoxShadow,
                    color: colors.dark[900],
                    transition: transition,
                },
            };
        }
        return {
            initial: {},
            animate: {},
            whileHover: {},
            whileTap: {},
        };
    }
    var icon = props.icon;
    var ariaProps = {};
    if (props.onlyIcon) {
        ariaProps = {
            "aria-label": props.label,
        };
    }
    var hasIcon = !!icon;
    return ((0, jsx_runtime_1.jsxs)(framer_motion_1.motion.button, __assign({ className: (0, client_utils_1.classNames)("focus:outline-focus relative flex items-center gap-2 rounded font-semibold focus:outline-1 disabled:pointer-events-none", !!hasIcon && !props.onlyIcon && "justify-between", (!hasIcon || props.onlyIcon) && "justify-center", props.onlyIcon && "h-8 w-8", !props.onlyIcon && variant !== "text" && "px-4 py-2", actAsDisabled && "pointer-events-none", size === "sm" && "text-sm", size === "md" && "text-base", size === "lg" && "text-lg", props.className
        //props.className,
        ), disabled: actAsDisabled, type: type !== null && type !== void 0 ? type : "button", style: margin }, getAnimations(), { ref: buttonRef, onClick: props.onClick }, ariaProps, rest, { children: [icon && icon.position === "leading" && ((0, jsx_runtime_1.jsx)(IpisIconRouter_1.IpisIconRouter, { icon: icon.type, size: "sm" })), !props.onlyIcon && ((0, jsx_runtime_1.jsxs)(framer_motion_1.motion.div, { className: "flex flex-col", children: [(0, jsx_runtime_1.jsx)(framer_motion_1.motion.span, { className: (0, client_utils_1.classNames)("flex items-center justify-center gap-2  transition-all", !!loading && "opacity-40", props.variant === "text" && props.underline && "underline"), children: props.label }), !!props.sublabel && ((0, jsx_runtime_1.jsx)(framer_motion_1.motion.span, { className: (0, client_utils_1.classNames)("text-semi-faded flex items-center gap-2 text-xs italic", !!loading && "opacity-40", hasIcon && "justify-end", !hasIcon && "justify-center"), children: props.sublabel }))] })), icon && icon.position === "trailing" && ((0, jsx_runtime_1.jsx)(IpisIconRouter_1.IpisIconRouter, { icon: icon.type, size: "sm" }))] })));
}
